// NPM Modules
import { writable } from 'svelte/store';
import collect from 'collect.js';
// Models
import ClassificationBetType from '@/Models/ClassificationBetType.js';

/**
 * Our Store can be used 2 ways in svelte components
 * 1) ($ prefix) $StoreName to reference writable store collection with all collect.js methods available
 * 2) (Direct) StoreName.method() to call a method on the store
 */
const init = () => {
	const { subscribe, set, update } = writable(collect());

	const methods = {
		updateClassificationBetTypes(classificationId, data) {
			const classificationBetType = new ClassificationBetType();

			return classificationBetType.update(classificationId, data);
		}
	};

	return {
		subscribe,
		update,
		set,
		...methods
	};
};

export default init();
